// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"5cdb1fcb","245":"fe2aa3cf","634":"7149c423","689":"c0e49086","714":"91587309","759":"d2e64c74","804":"261f846f","884":"bdf70e29","965":"21fe6933"}[chunkId] + ".chunk.js";
};